<div class="inputGrid w-full">
    <app-input-fulltext
        [form]="form"
        [options]="store.history()"
        (selectedOptionChange)="selectedChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!store.isAllowed('individualPlan.create')() || store.isTerminated()"
        (clickEvent)="save()"
        [loading]="store.loadingAny() || offersInput.offersScroll().loading()"
        icon="pi-save"
        label="inputs.save"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        severity="secondary"
        label="common.print"
        class="white-space-nowrap justify-self-end"
        (clickEvent)="print()"
    ></app-button>

    <div class="flex-column gap left-container">
        <div class="flex gap w-full pt-2">
            <app-date-input
                [form]="form"
                id="date"
                [showTime]="true"
                [showClear]="false"
            ></app-date-input>

            <app-tags-input
                class="w-full"
                label="individualPlan.fields.tags"
                [suggestions]="store.data.getIndividualPlanServiceTagsByFolder() || []"
                [form]="form"
                id="tags"
            ></app-tags-input>
        </div>

        <ng-template #showAllTargets>
            @if (inactiveTargets()) {
                <app-switch-input
                    id="showAllTargets"
                    [form]="form"
                    label="individualPlan.message.showClosedTargets"
                ></app-switch-input>
            }
        </ng-template>
        <app-table
            [afterTitle]="showAllTargets"
            [columns]="targetColumns"
            [showSearch]="false"
            [items]="visibleTargets()"
            translatePrefix="individualPlan.target."
            [tableTitle]="visibleTargets().length <= 1 ? 'individualPlan.fields.target' : 'individualPlan.fields.targets'"
            (createCallback)="upsertTarget()"
            (detailCallback)="upsertTarget($event)"
            (deleteCallback)="deleteTarget($event)"
            [hideCheckboxes]="true"
        >
            <ng-template pTemplate="status" let-data="data">
                <app-tag
                    [severity]="$any(individualPlanTargetStatusColor[data])"
                    [label]="'individualPlan.target.status.' + data"
                    [rounded]="true"
                ></app-tag>
            </ng-template>
        </app-table>

        <app-social-service-offers-select-input
            #offersInput
            [date]="form.value.date"
            [folderId]="store.folderId()"
        ></app-social-service-offers-select-input>

        <app-service-pattern-wysiwyg
            placeholder="individualPlan.fields.situation"
            [form]="form"
            id="situation"
            editorKey="individualPlan.situation"
            [height]="undefined"
            [serviceId]="store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0"
            [folderId]="folderStore.folderId()"
            [usage]="ServicePatternStructureUsageEnum.INDIVIDUAL_PLAN_SITUATION"
            (addedPattern)="formAddText(form, 'situation', $event.content)"
            [patternGroups]="wysiwygPatterGroupsFolder"
        ></app-service-pattern-wysiwyg>

        <div class="flex gap w-full">
            <app-service-pattern-wysiwyg
                class="flex-grow-1"
                placeholder="individualPlan.fields.process"
                [form]="form"
                id="process"
                editorKey="individualPlan.process"
                [height]="undefined"
                [serviceId]="store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0"
                [folderId]="folderStore.folderId()"
                [usage]="ServicePatternStructureUsageEnum.INDIVIDUAL_PLAN_PROCESS"
                (addedPattern)="formAddText(form, 'process', $event.content)"
                [patternGroups]="wysiwygPatterGroupsFolder"
            ></app-service-pattern-wysiwyg>
            <app-file-upload-box
                class="pt-3"
                [multiple]="true"
                [existingFiles]="form.value.files"
            ></app-file-upload-box>
        </div>

        <app-service-pattern-wysiwyg
            placeholder="individualPlan.fields.evaluation"
            [form]="form"
            id="evaluation"
            editorKey="individualPlan.evaluation"
            [height]="undefined"
            [serviceId]="store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0"
            [folderId]="folderStore.folderId()"
            [usage]="ServicePatternStructureUsageEnum.INDIVIDUAL_PLAN_EVALUATION"
            (addedPattern)="formAddText(form, 'evaluation', $event.content)"
            [patternGroups]="wysiwygPatterGroupsFolder"
        ></app-service-pattern-wysiwyg>

        <div class="flex gap">
            <app-date-input
                [form]="form"
                timeType="midDay"
                id="revisionDate"
                prefix="individualPlan."
            ></app-date-input>
            <app-select-user
                class="w-full"
                [form]="form"
                id="revisionUserId"
                label="individualPlan.fields.revisionUserId"
                [serviceId]="store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0"
                [employment]="EmploymentParentGroupEnum.DIRECT_CARE"
            ></app-select-user>
        </div>
    </div>

    <p-listbox class="fr-2"
        [options]="store.history()"
        [(ngModel)]="selectedItem"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'individualPlan.message.history' | translate"
        (onFilter)="searchSubject.next($event.filter)"
        filterBy="situation,evaluation,process,searchExt"
        optionLabel="createdAt"
        dataKey="index"
        styleClass="h-full"
        scrollHeight="calc(100vh - 20rem)"
        [emptyMessage]="'inputs.noResultsFound' | translate"
    >
        <ng-template #item let-item>
            <div (contextmenu)="rightClick(contextMenu, $event, item)" class="w-full">
                <div class="flex-column gap-x-small pl-1">
                    <div class="flex justify-content-between">
                        <div>{{ item.createdAt }}</div>
                        <div class="flex gap-x-small align-items-center">
                            @for (altered of item.changes; track altered) {
                                @if (altered == 'files') {
                                    <i class="pi pi-file"></i>
                                } @else if (altered == 'tags') {
                                    <i class="pi pi-tag"></i>
                                } @else {
                                    <abbr> {{ 'individualPlan.abbr.' + altered | translate }}</abbr>
                                }
                            }
                        </div>
                    </div>
                    @if (item.user) {
                        <app-user-chip [user]="item.user"></app-user-chip>
                    }
                    @if (item.tags) {
                        <div class="flex gap-x-small flex-wrap historyTagList">
                            @for (tag of item.tags; track tag) {
                                <app-tag [label]="tag"></app-tag>
                            }
                        </div>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu
    #contextMenu
    [model]="contextMenuItems"
    appendTo="body"
    styleClass="individual-plan-context-menu"
></p-contextMenu>
